import { TicketReader } from './TicketReader';

export class TicketDetailReader extends TicketReader {
  constructor(ticket) {
    super(ticket);
  }

  get status() {
    return this.ticket.currentStatus;
  }

  get clientName() {
    const { formValues } = this;
    if (!formValues.firstName && !formValues.lastName) {
      return null;
    }

    return `${formValues.firstName} ${formValues.lastName}`;
  }

  get actions() {
    return this.ticket.availableActions;
  }

  get formValues() {
    return this.ticket.formValues;
  }

  get fromIban() {
    return this.ticket.fromIBAN;
  }

  get toIban() {
    return this.ticket.toIBAN;
  }

  get comments() {
    return this.ticket.comments;
  }

  get history() {
    return this.ticket.history;
  }

  get documents() {
    return this.ticket.documents;
  }

  get nextDeadline() {
    return this.ticket.nextDeadline;
  }

  get nextDeadlineInBankDays() {
    return this.ticket.numberOfBankDaysTillNextDeadline;
  }

  get availableActions() {
    return this.ticket.availableActions;
  }

  get address() {
    return this.ticket.formValues.address;
  }

  get postcode() {
    return this.ticket.formValues.postcode;
  }

  get city() {
    return this.ticket.formValues.city;
  }

  get birthday() {
    return this.ticket.formValues.birthday;
  }

  get accountswitchSpecificDate() {
    return this.ticket.formValues.accountswitchSpecificDate;
  }

  get email() {
    return (
      this.ticket.guidanceRequest &&
      this.ticket.guidanceRequest.data &&
      this.ticket.guidanceRequest.data.emailAddress
    );
  }

  get transferringIban() {
    return this.ticket.fromIBAN;
  }

  get receivingIban() {
    return this.ticket.toIBAN;
  }

  get newBankName() {
    return this.ticket.newBankName;
  }

  get oldBankName() {
    return this.ticket.oldBankName;
  }
}
